import createVueApp from '@/common/createApp'

Styxie.Initializers.MlapSettingsIntegrations = {
  index: async(props) => {
    const { default: SettingsIntegrations } = await import('@/vue_widgets/mlap/settings/integrations/index.vue')
    createVueApp(SettingsIntegrations, { props })
  }
}
